/**
 * In-memory cache for Open Return Age drilldown pages.
 * Dropped whenever dashboard filters change — never persisted.
 */

export const openAgeCacheKey = ({
  clientId,
  startDate,
  endDate,
  channels = [],
  ageBucket,
  stage,
  skip = 0,
  limit = 25,
  sortField = "age_days",
  sortDir = "desc",
} = {}) =>
  JSON.stringify({
    clientId: clientId || "",
    startDate: startDate || "",
    endDate: endDate || "",
    channels: [...(channels || [])].filter(Boolean).sort(),
    ageBucket: ageBucket || "",
    stage: stage || "",
    skip,
    limit,
    sortField,
    sortDir,
  });

export class OpenAgeMemoryCache {
  constructor() {
    this.map = new Map();
  }

  get(key) {
    return this.map.get(key);
  }

  set(key, value) {
    this.map.set(key, value);
  }

  clear() {
    this.map.clear();
  }
}
